import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import AllDocumentsService from "services/AllDocumentsService";

let initialState = {
  list: [],
  detail: {},
  consults: [],
  logs: [],
  translateData: null,
};

export const getAllDocumentsList = createAsyncThunk(
  "allDocuments/getallDocuments",
  async (body) => {
    const response = await AllDocumentsService.getAllDocuments(body);
    return response?.results;
  }
);

export const approveDoc = createAsyncThunk(
  "allDocuments/approveDoc",
  async (body) => {
    const response = await AllDocumentsService.approveDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);
export const CheckpropertiesLog = createAsyncThunk(
  "allDocuments/checkpropertieslog",
  async (body) => {
    const response = await AllDocumentsService.CheckProLog(body);
    if (response.status) {
      // const res = await AllDocumentsService.getAllDocuments(body);
      // if (res.status && res.results.length > 0) {
      //   const detail = res.results[0];
      //   return detail;
      // }
    }
  }
);

export const Departmentupload = createAsyncThunk(
  "allDocuments/departmentupload",
  async (body) => {
    const response = await AllDocumentsService.Departmentupload(body);
    if (response.status) {
      // const res = await AllDocumentsService.getAllDocuments(body);
      // if (res.status && res.results.length > 0) {
      //   const detail = res.results[0];
      //   return detail;
      // }
    }
  }
);

export const forceApprove = createAsyncThunk(
  "allDocuments/forceApprove",
  async (body) => {
    const response = await AllDocumentsService.forceApprove(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const otherApproveDoc = createAsyncThunk(
  "allDocuments/otherApproveDoc",
  async (body) => {
    console.log(body);
    const response = await AllDocumentsService.otherApproveDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const healthinsuranceApprove = createAsyncThunk(
  "allDocuments/healthinsuranceApprove",
  async (body) => {
    console.log(body);
    const response = await AllDocumentsService.healthinsuranceApprove(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const boiapproveex = createAsyncThunk(
  "allDocuments/boiapproveex",
  async (body) => {
    console.log(body);
    const response = await AllDocumentsService.boiapproveex(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const boiRecieved = createAsyncThunk(
  "allDocuments/boirecieved",
  async (body) => {
    const response = await AllDocumentsService.boirecieved(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];

        return detail;
      }
    }
  }
);

export const returndraft = createAsyncThunk(
  "allDocuments/returndraft",
  async (body) => {
    const response = await AllDocumentsService.returndraft(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const undoDoc = createAsyncThunk(
  "allDocuments/undoDoc",
  async (body) => {
    const response = await AllDocumentsService.undo(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const otherUndo = createAsyncThunk(
  "allDocuments/otherUndo",
  async (body) => {
    const response = await AllDocumentsService.otherUndo(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const rejectDoc = createAsyncThunk(
  "allDocuments/rejectDoc",
  async (body) => {
    const response = await AllDocumentsService.rejectDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const ReasonOtherdep = createAsyncThunk(
  "allDocuments/ReasonOtherdep",
  async (body) => {
    const response = await AllDocumentsService.ReasonOtherDep(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const completeDoc = createAsyncThunk(
  "allDocuments/completeDoc",
  async (body) => {
    const response = await AllDocumentsService.completetDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments(body);
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const requestDocuments = createAsyncThunk(
  "allDocuments/requestDocuments",
  async (body) => {
    const response = await AllDocumentsService.requestDocuments(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments({
        draftId: body.draftId,
      });
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const reassignDoc = createAsyncThunk(
  "allDocuments/reassignDoc",
  async (body) => {
    const response = await AllDocumentsService.reassignDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments({
        draftId: body.draftId,
      });
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const consultDoc = createAsyncThunk(
  "allDocuments/consultDoc",
  async (body) => {
    const response = await AllDocumentsService.consultDoc(body);
    if (response.status) {
      const res = await AllDocumentsService.getAllDocuments({
        draftId: body.draftId,
      });
      if (res.status && res.results.length > 0) {
        const detail = res.results[0];
        return detail;
      }
    }
  }
);

export const superaccessList = createAsyncThunk(
  "allDocuments/superaccessList",
  async (body) => {
    const response = await AllDocumentsService.superaccessList(body);
    if (response.status) {
      return response.results;
    }
  }
);

export const superaccessremove = createAsyncThunk(
  "allDocuments/superaccessremove",
  async (body) => {
    const response = await AllDocumentsService.superaccessremove(body);
    if (response.status) {
      return response.status;
    }
  }
);

export const docLogs = createAsyncThunk(
  "allDocuments/docLogs",
  async (body) => {
    const response = await AllDocumentsService.docLogs(body);
    if (response.status) {
      return response.results;
    }
  }
);

export const translateDoc = createAsyncThunk(
  "allDocuments/translateDoc",
  async (body) => {
    const response = await AllDocumentsService.translateDoc(body);
    if (response.status) {
      return response.results;
    }
  }
);

const allDocumentsSlice = createSlice({
  name: "allDocuments",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
    setDocDetail(state, action) {
      state.detail = action.payload;
    },
    clearConsults(state, action) {
      state.consults = [];
    },
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getAllDocumentsList, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(approveDoc, builder, ["detail"]);

    LoadingAdapter.applyAsyncBuilder(undoDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(otherUndo, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(rejectDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(ReasonOtherdep, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(healthinsuranceApprove, builder, [
      "detail",
    ]);
    LoadingAdapter.applyAsyncBuilder(returndraft, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(otherApproveDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(reassignDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(consultDoc, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(superaccessList, builder, ["consults"]);
    LoadingAdapter.applyAsyncBuilder(docLogs, builder, ["logs"]);
    LoadingAdapter.applyAsyncBuilder(forceApprove, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(requestDocuments, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(boiapproveex, builder, ["detail"]);
    LoadingAdapter.applyAsyncBuilder(boiRecieved, builder, ["detail"]);

    LoadingAdapter.applyAsyncBuilder(translateDoc, builder, ["translateData"]);
  },
});

export const { setDocDetail, clearConsults } = allDocumentsSlice.actions;

export default allDocumentsSlice.reducer;
